import { useEffect } from 'react';
import { useUiStore } from '@/shared/store/ui-store';

export function ThemeBridge() {
  const theme = useUiStore((s) => s.theme);
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('dark', theme === 'dark');
    root.style.colorScheme = theme;
  }, [theme]);
  return null;
}
